import { useEffect, useState } from "react";
import { ProgramsService } from "services/programs";
import { ProgramStatisticsCountResult } from "services/programs/models/ProgramTypes";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";

const ProgramCountTiles = () => {
  const [statistics, setStatistics] = useState<ProgramStatisticsCountResult | null>(null);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
const  nav= useNavigate();
  useEffect(() => {
    fetchStatistics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const response = await ProgramsService.getProgramStatisticsCount();
      if (!response.hasError && response.data) {
        setStatistics(response.data);
      }
    } catch (error) {
      console.error("Error fetching program statistics count:", error);
    } finally {
      setLoading(false);
    }
  };

  const tileStyle = {
    border: 'none',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
  };

  const iconContainerStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.8rem',
  };

  if (loading) {
    return (
      <div className="row mb-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card" style={tileStyle}>
              <div className="card-body text-center p-4">
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row mb-4">
      {/* Total Programs Tile */}
      <div className="col-md-4 mb-3">
        <div
            
          className="card"
          style={tileStyle}
          onClick={()=>nav('/home/programs')}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.07)';
          }}
        >
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="text-muted mb-2 small fw-semibold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                  {t("Dashboard:totalPrograms")}
                </p>
                <h2 className="mb-0 fw-bold" style={{ fontSize: '2.5rem', color: '#2c3e50' }}>
                  {statistics?.totalPrograms || 0}
                </h2>
              </div>
              <div
                style={{
                  ...iconContainerStyle,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                }}
              >
                <i className="bi bi-clipboard-data"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Total Active Programs Tile */}
      <div className="col-md-4 mb-3">
        <div
          className="card"
          style={tileStyle}
          onClick={()=>nav('/home/programs')}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.07)';
          }}
        >
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="text-muted mb-2 small fw-semibold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                  {t("Dashboard:totalActiveProgram")}
                </p>
                <h2 className="mb-0 fw-bold" style={{ fontSize: '2.5rem', color: '#2c3e50' }}>
                  {statistics?.totalActiveProgram || 0}
                </h2>
              </div>
              <div
                style={{
                  ...iconContainerStyle,
                  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                  color: 'white',
                }}
              >
                <i className="bi bi-check2-circle"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Total Inactive Programs Tile */}
      <div className="col-md-4 mb-3">
        <div
          className="card"
          style={tileStyle}
          onClick={()=>nav('/home/programs')}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.07)';
          }}
        >
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="text-muted mb-2 small fw-semibold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                  {t("Dashboard:totalInActiveProgram")}
                </p>
                <h2 className="mb-0 fw-bold" style={{ fontSize: '2.5rem', color: '#2c3e50' }}>
                  {statistics?.totalInActiveProgram || 0}
                </h2>
              </div>
              <div
                style={{
                  ...iconContainerStyle,
                  background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                  color: 'white',
                }}
              >
                <i className="bi bi-x-circle"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramCountTiles;